import {clsx} from "clsx";

export default function PageHeader({
  title,
  className,
  ignoreSpacing,
    actions,
}) {
  return(
    <div className={clsx({"ml-4 mt-4": !ignoreSpacing, "w-full flex flex-row justify-between items-center": actions}, className)}>
      <h4 className="text-xl w-full py-2 text-gray-500 uppercase">{title}</h4>
        {actions ? (
            <div className="">
                {actions}
            </div>
        ) : null}

    </div>
  );
}